import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { ENUM_ROUTES } from "../../RoutesEnum";
import { NewsApiResponse } from "../../types/General";
import moment from "moment";
import { showError, showToast } from "../../constants/toasts";
import {
  useDeleteNewsMutation,
  useUpdateNewsMutation,
} from "../../services/news";
import { ConfirmationModal } from "../../Modals/ConfirmationModal";
import CustomToggle from "../../helpers/CustomToggle";

interface NewsListProps {
  NewsData: NewsApiResponse[];
  fetchNews: () => void;
}

const NewsList = ({ NewsData, fetchNews }: NewsListProps) => {
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [deleteNews] = useDeleteNewsMutation();
  const [updateNews] = useUpdateNewsMutation();

  const toggleStatus = async (id: string, currentStatus: boolean) => {
    try {
      const response = await updateNews({
        id,
        body: { status: !currentStatus },
      }).unwrap();

      if (response?.statusCode === 200) {
        showToast(
          `News ${!currentStatus ? "activated" : "deactivated"} successfully`
        );
        fetchNews();
      } else {
        showError("Failed to Active News status");
      }
    } catch (error: any) {
      showError(error?.data?.message || "Failed to update News status");
    }
  };

  const deleteNewsApi = async (id: string) => {
    setLoading(true);
    try {
      const response = await deleteNews({
        id,
      }).unwrap();
      setLoading(false);
      if (response?.statusCode === 200) {
        showToast(response?.message || "News Deleted Successfully");
        fetchNews();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  const columns: GridColDef<(typeof NewsData)[any]>[] = [
    {
      field: "image",
      headerName: "Image",
      flex: 1,
      minWidth: 120,
      sortable: false,
      renderCell: (params) => (
        <img
          src={params.value || "/static/images/picture.png"}
          alt="news"
          style={{
            width: "60%",
            maxWidth: 100,
            height: 40,
            objectFit: "cover",
            borderRadius: 8,
          }}
        />
      ),
    },
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "authorName",
      headerName: "Author",
      flex: 1,
      minWidth: 120,
      sortable: false,
    },
    // {
    //   field: "category",
    //   headerName: "Category",
    //   flex: 1,
    //   minWidth: 120,
    //   sortable: false,
    // },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      minWidth: 120,
      sortable: false,
      renderCell: (params) => {
        return moment(params.value).format("MMM DD, YYYY");
      },
    },
    // {
    //   field: "content",
    //   headerName: "Content",
    //   flex: 1,
    //   minWidth: 200,
    //   sortable: false,
    //   renderCell: (params) => (
    //     <Typography
    //       sx={{
    //         overflow: "hidden",
    //         textOverflow: "ellipsis",
    //         whiteSpace: "nowrap",
    //         maxWidth: 200,
    //       }}
    //     >
    //       {params.value}
    //     </Typography>
    //   ),
    // },
    {
      field: "status",
      headerName: "Active",
      align: "center",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params: any) => (
        <CustomToggle
          checked={params.value || false}
          onChange={() =>
            toggleStatus(params.row._id || params.row.id, params.value)
          }
          id={params.row._id || params.row.id}
        />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 130,
      sortable: false,
      renderCell: (params) => (
        <Box className="table_actions v2">
          <IconButton
            onClick={() =>
              navigate(ENUM_ROUTES.NEWS_DETAILS + `/${params.row._id}`)
            }
          >
            <img src="/static/images/eye_icon.svg" alt="View" />
          </IconButton>
          <IconButton
            onClick={() =>
              navigate(ENUM_ROUTES.EDIT_NEWS + `/${params?.row?._id}`)
            }
          >
            <img src="/static/images/edit2_icon.svg" alt="Edit" />
          </IconButton>
          <IconButton
            onClick={() => {
              setSelectedId(params?.row?._id);
              setOpen(true);
            }}
          >
            <img src="/static/images/trash2_icon.svg" alt="Delete" />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <div className="sorting_table">
      <TableComponent columns={columns} rows={NewsData} />
      <ConfirmationModal
        text={"Are you sure you want to Delete this News?"}
        openModal={open}
        setOpenModal={setOpen}
        handleSubmit={() => deleteNewsApi(selectedId)}
      />
    </div>
  );
};

export default NewsList;
